import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss'
//import ConversationClass from '/chat/src/lib/Conversation';
import {TicketModel} from '/chat/src/redux/model';

import Customization from '/chat/src/redux/model/customization/model';

class ResumeConversationButton extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    render(){
        return (
            <div className={style.NewConversationWrapper}>
                <div style={{
                        width: '100%',
                        position: 'absolute',
                        height: '65px',
                        bottom: '0px',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)'
                    }}>
                <div
                    className={style.NewConversationButton}
                    style={{backgroundColor: this.props.color}}
                    onClick={this.handleClick}>
                        <div className={style.NewConversationText}>
                            {this.props.language.get("ResumeChatting")}
                        </div>
                </div>
                </div>
            </div>
        );
    }

    handleClick() {
        this.props.dispatch(TicketModel.requestReopenTicket(this.props.room))
    }
}

function mapStateToProps(state) {
    const language = Customization.getLanguage(state)
    const color = Customization.getColor(state);
    const room = TicketModel.getCurrentRoom(state)
    return {
        room, language, color
    };
}

export default connect(mapStateToProps)(ResumeConversationButton);



// WEBPACK FOOTER //
// ./routes/Chat/NewConversationButton/index.js